import React from 'react';
import c from 'classnames';

import Download, { DownloadProps } from './Download';

import './style.scss';

export interface DownloadsProps {
  downloads: Omit<DownloadProps, 'materialIconName' | 'target'>[];
  target?: HTMLAnchorElement['target'];
  materialIconName: string;
  className?: string;
}

const Downloads: React.FC<DownloadsProps> = ({
  downloads,
  target,
  materialIconName,
  className,
}) => {
  const classes = c('Downloads', className);

  return (
    <div className={classes}>
      {downloads.map((download) => (
        <Download
          key={download.filename}
          source={download.source}
          title={download.title}
          description={download.description}
          filesize={download.filesize}
          filename={download.filename}
          materialIconName={materialIconName}
          target={target}
        />
      ))}
    </div>
  );
};

export default Downloads;
